import React, { useEffect, useContext } from "react";
import { documentosSolicitadosAtom } from "../store/MisSolicitudesDocumentosStore";
import { useAtom } from "jotai";
import TipoDocumentoService from "services/TipoDocumentoService";
import { CategoriaDocumento } from "enum/CategoriaDocumento";
import { SecurityContext } from "context/SecurityContextProvider";

const useListarDocumentos = () => {
	const [documentos, setDocumentos] = useAtom(documentosSolicitadosAtom);
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	// Documentos que se excluyen según el estado
	const DOCUMENTOS_EXCLUIDOS_ACTIVO = ["Certificado de Trabajo"];
	const estadoColaborador = getUsuarioAutenticado()
					?.empresaSeleccionada
					?.colaborador
					?.estado;
	
	useEffect(() => {
		const cargarDatos = async () => {
			const documentosPersonales = await TipoDocumentoService.listarDocumentosPersonales(
				"",
				CategoriaDocumento.DOCUMENTO_PERSONAL
			);

			// Filtrar según el estado
			const documentosFiltrados = estadoColaborador === "ACTIVO"
				? documentosPersonales.filter(
					doc => doc && !DOCUMENTOS_EXCLUIDOS_ACTIVO.includes(doc.nombre)
				)
			: documentosPersonales;
			
			setDocumentos(documentosFiltrados);
		};
		cargarDatos();
	}, []);
	return { documentos };
};
export default useListarDocumentos;
